import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet-async'
import { HeroSection } from '@/components/sections/HeroSection'
import { TextSection } from '@/components/sections/TextSection'
import { StrengthPoints } from '@/components/sections/StrengthPoints'
import { MethodSteps } from '@/components/sections/MethodSteps'
import { QuoteCTA } from '@/components/sections/QuoteCTA'

export default function Home() {
  const { t, i18n } = useTranslation('common')

  return (
    <>
      <Helmet>
        <title>{t('home.seo.title')}</title>
        <meta name="description" content={t('home.seo.description')} />
        <html lang={i18n.language} />
      </Helmet>

      <HeroSection
        imageSrc="/images/company-hero.jpg"
        title={t('home.hero.title')}
        subtitle={t('home.hero.subtitle')}
        slogan={t('home.hero.slogan')}
        sloganPosition="top"
        fullScreen
        blurEdges
        primaryCta={{ label: t('buttons.contactUs'), to: 'contacts' }}
        secondaryCta={{ label: t('nav.services'), to: 'services' }}
      />

      <TextSection
        heading={t('home.intro.heading')}
        body={t('home.intro.body')}
        align="center"
        cta={{ label: t('buttons.learnMore'), to: 'history' }}
      />

      <MethodSteps />

      <QuoteCTA />

      <StrengthPoints />
    </>
  )
}
